module.exports = __webpack_public_path__ + "img/3c.ba4af34e.svg";